import { authenticationConstants } from "../_constants/authentication.constants";

const initialState = {
  isOpenModal: false,
  isOpenErrorMessageModal: false,
  isOpenVerify2FactorModal: false,
  isLoading2FA: false,

  user: null,
  accountList: [],
  mkt: null,
  isMobileCompletedLogin: false,
  getAccountMKT: false,
  getAccountListSuccess: false,
  accountInfo: null,
  accountName: null,
  isSignIn: false,
  isFetching: false,
  errorMessage: null,
  referenceCode: null,
  twoFactorId: null,
  twoFactorAuthenticationMethod: null,
  twoFactorToken: null,

  logInType: null,
};

const authenticationReducer = (state = initialState, action) => {
  switch (action.type) {
    case authenticationConstants.TOGGLED_SIGN_IN_MODAL:
      return {
        ...state,
        isOpenModal: !state.isOpenModal,
      };
    case authenticationConstants.TOGGLED_ERROR_MESSAGE_MODAL:
      return {
        ...state,
        isOpenErrorMessageModal: !state.isOpenErrorMessageModal,
      };
    case authenticationConstants.SIGN_IN_CREDENTIAL_START:
      return {
        ...state,
        isFetching: true,
      };
    case authenticationConstants.SIGN_IN_DSA_START:
      return {
        ...state,
        isFetching: true,
      };
    case authenticationConstants.SIGN_IN_SSO_START:
      return {
        ...state,
        isFetching: true,
      };
    case authenticationConstants.SIGN_IN_START:
      return {
        ...state,
        isFetching: true,
      };
    case authenticationConstants.SIGN_IN_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isSignIn: true,
        user: action.payload.user,
        logInType: action.payload.logInType,
        isLoading2FA: false,
      };
    case authenticationConstants.VERIFY_2FA_OPEN:
      return {
        ...state,
        twoFactorAuthenticationMethod:
          action.payload.twoFactorAuthenticationMethod,
        referenceCode: action.payload.referenceCode,
        twoFactorId: action.payload.twoFactorId,
        isOpenVerify2FactorModal: true,
        isLoading2FA: false,
        twoFactorToken: action.payload.twoFactorToken,
      };
    case authenticationConstants.TOGGLED_2FA_MODAL:
      return {
        ...state,
        isOpenVerify2FactorModal: !state.isOpenVerify2FactorModal,
      };
    case authenticationConstants.SET_2FA_LOADING:
      return {
        ...state,
        isLoading2FA: action.payload,
      };
    case authenticationConstants.SIGN_IN_SUCCESS_FOR_MOBILE:
      return {
        ...state,
        isFetching: false,
        isSignIn: true,
        logInType: action.payload.logInType,
      };
    case authenticationConstants.SIGN_IN_FAILURE:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.payload,
        isSignIn: false,
        user: null,
        logInType: undefined,
        isLoading2FA: false,
        isOpenVerify2FactorModal:
          action.payload === "Invalid OTP Reference" ? true : false,
      };
    case authenticationConstants.CLEAR_SIGN_IN_ERROR_MESSAGE:
      return {
        ...state,
        errorMessage: null,
      };
    // case authenticationConstants.GET_ACCOUNT_LIST_START:
    //   return {
    //     ...state,
    //   };
    case authenticationConstants.GET_ACCOUNT_MKT:
      return {
        ...state,
        mkt: action.payload ?? "",
        getAccountMKT: true,
      };
    case authenticationConstants.GET_ACCOUNT_LIST_SUCCESS:
      return {
        ...state,
        accountList: action.payload ?? [],
        getAccountListSuccess: true,
      };
    case authenticationConstants.UPDATE_ACCOUNT_LIST_MOBILE_SUCCESS:
      return {
        ...state,
        isMobileCompletedLogin: true,
      };
    case authenticationConstants.GET_ACCOUNT_LIST_FAILURE:
      return {
        ...state,
        accountList: [],
        errorMessage: action.payload ?? null,
        getAccountListSuccess: false,
      };
    case authenticationConstants.GET_ACCOUNT_INFO_START:
      return {
        ...state,
        isFetching: true,
      };
    case authenticationConstants.GET_ACCOUNT_INFO_SUCCESS:
      return {
        ...state,
        isFetching: false,
        accountInfo: action.payload,
      };
    case authenticationConstants.GET_ACCOUNT_INFO_FAILURE:
      return {
        ...state,
        accountInfo: null,
      };
    case authenticationConstants.GET_ACCOUNT_NAME_SUCCESS:
      return {
        ...state,
        accountName: action.payload,
      };
    case authenticationConstants.GET_ACCOUNT_NAME_FAILURE:
      return {
        ...state,
        accountName: null,
      };
    case authenticationConstants.SIGN_OUT: {
      return {
        ...initialState,
      };
    }
    default:
      return state;
  }
};

export default authenticationReducer;
